import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {ObjektDataService} from 'src/app/services/objekt-data.service';
import {DeviceDetectionService} from '../../services/device-detection-service';

@Component({
    selector: 'app-termin', templateUrl: './termin.component.html', styleUrls: ['./termin.component.scss'],
})
export class TerminComponent implements OnInit {
    // todo 26-01-26 https://swissjira.atlassian.net/browse/EN-4392 check if removable
    constructor(private router: Router, private route: ActivatedRoute, private svcObjektData: ObjektDataService, private deviceDetectionService: DeviceDetectionService) {
        let lastUrl = this.route.snapshot.queryParams.returnUrl;
        let url = lastUrl || '/pendenzen/kalender';
        let objectID = this.svcObjektData.getCurrentObjectID();
        if (objectID) {
            this.router.navigate([url]);
        }
    }

    ngOnInit(): void {
        this.navigate();
    }

    async navigate() {
        let url = '/pendenzen';
        if (this.deviceDetectionService.getDevice().device.type == 'mobile') {
            url = '/termin-mobile';
        }
        await this.router.navigate([url]);
    }
}
